(function(app, $) {
    var $cache = {},
        openedSlideshow = false,
        slideshowHeight = 0;

    function initializeCache() {
        $cache.window = $(window);
        $cache.body = $('body');
        $cache.slideshow = $cache.body.find('.slideshow');
    }

    function initializeEvents() {
        $cache.window.on('load', function() {
            slideshowHeight = $cache.slideshow.find('ul li:visible img').height();
            changeSlideshowHeight(slideshowHeight / 2, '-50%');
            openedSlideshow = false;
        });

        var timeoutResize;
        $cache.window.resize(function() {
            if(typeof timeoutResize !== 'undefined') {
                clearTimeout(timeoutResize);
            }
            timeoutResize = setTimeout(function() {
                slideshowHeight = $cache.slideshow.find('ul li:visible img').height();
                changeSlideshowHeight(slideshowHeight / 2, '-50%');
                openedSlideshow = false;
            }, 50);
        });

        $cache.slideshow.on('click', function(e) {
            if(!app.device.isMobile && !$(e.target).parent().is('a, a*') && e.target.className.indexOf('jcarousel-control') === -1) {
                if(openedSlideshow) {
                    changeSlideshowHeight(slideshowHeight / 2, '-50%');
                    openedSlideshow = false;
                }
                else {
                    changeSlideshowHeight(slideshowHeight, '0%');
                    openedSlideshow = true;
                }
            }
        });
    }

    function changeSlideshowHeight(height, top) {
        $cache.slideshow.animate({
            'height' : height
        }, app.preferences.jcarousel.heightanimationduration);
        $cache.slideshow.find('.jcarousel').animate({
            'top' : top
        }, app.preferences.jcarousel.heightanimationduration);
    }

    app.components = app.components || {};
    app.components.slideshow = {
        init : function() {
            initializeCache();
            initializeEvents();
        }
    };
}(window.app = window.app || {}, jQuery));
